import { useState } from 'react'

import { Cell } from '../../../../components/ReusableComponents/Table'
import DateTooltip from './DateTooltip'
import styles from './HotelNameCell.module.scss'

const HotelNameCell = ({
  brand,
  name,
  groupName,
  navigationControl,
  serviceStartDate,
  actualServiceStartDate,
  subsidiaryId,
  ...props
}) => {
  const [isHovering, setHovering] = useState(false)

  return (
    <Cell
      className={
        navigationControl ? styles.hotelNameCellWithNavigation : styles.hotelNameCell
      }
      {...props}
      noHoverStyle
    >
      <div className={styles.wrapper}>
        <div className={styles.hotelBrand}>{brand}</div>
        <div
          className={styles.hotelShortName}
          onMouseOver={() => setHovering(true)}
          onMouseLeave={() => setHovering(false)}
        >
          {name}
          <DateTooltip
            serviceStartDate={serviceStartDate}
            actualServiceStartDate={actualServiceStartDate}
            isVisible={isHovering}
          />
        </div>
        {navigationControl && (
          <div className={styles.navigationControl}>{navigationControl}</div>
        )}
        {groupName && <div className={styles.tooltip}>{groupName}</div>}
      </div>
    </Cell>
  )
}

export default HotelNameCell
